import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { PageContext } from '@axiom/ui';

import ConvertUserIds from '../components/ConvertUserIds/ConvertUserIds';
import DefaultLayout from '../layouts/default';

/**
 * @param {{ name?: string }} props
 */
export const ConvertUserIdsPage = ({ name } = {}) => {
  const { setTitle } = useContext(PageContext);
  setTitle('Convert User Ids');
  return (
    <DefaultLayout>
      <ConvertUserIds />
    </DefaultLayout>
  );
};

ConvertUserIdsPage.propTypes = {
  name: PropTypes.string,
};
